import { Link } from "react-router-dom";

const NotFound = () => (
  <div data-testid="page-not-found" className="mx-auto max-w-3xl px-5 sm:px-8 py-32 text-center">
    <p className="eyebrow">404 · Page not found</p>
    <h1 className="mt-4 font-display text-4xl sm:text-5xl text-[var(--ink)]">
      That page drifted out to sea.
    </h1>
    <p className="mt-5 text-slate-600">
      Let’s get you back to safe harbor.
    </p>
    <Link
      to="/"
      data-testid="not-found-home-link"
      className="mt-8 inline-flex items-center rounded-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-dark)] text-white text-sm font-medium px-6 h-11 transition-colors"
    >
      Back home
    </Link>
  </div>
);

export default NotFound;
